/**
 * @logue/vue2-helpers
 *
 * @description A util package to use Vue 2 with Composition API easily
 * @version 2.1.6
 * @license Apache-2.0
 * @see {@link https://github.com/logue/vue2-helpers#readme}
 *
 * Build: 2023-04-20T10:43:35.985Z
 */
import { Vue2, getCurrentInstance } from 'vue-demi';
import Vuetify from 'vuetify/lib';

const { warn } = console;
const OUT_OF_SCOPE = 'getCurrentInstance() returned null. Method must be called at the top of a setup() function.';

/** Create Vuetify Instance */
function createVuetify(options) {
    Vue2?.use(Vuetify);
    return new Vuetify(options);
}
/** Vuetify Instance */
function useVuetify() {
    /** Vue instance */
    const instance = getCurrentInstance();
    if (instance?.proxy.$vuetify) {
        return instance.proxy.$vuetify;
    }
    warn(`[vue2-helpers/vuetify] ${OUT_OF_SCOPE}`);
    return undefined;
}
/** Use Display */
function useDisplay() {
    return useVuetify().breakpoint;
}
/** Theme */
function useTheme() {
    return useVuetify().theme;
}

export { createVuetify, useDisplay, useTheme, useVuetify };
//# sourceMappingURL=vuetify.es.js.map
